module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "correct"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    on: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("活动介绍")]), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', [_c('p', {
    staticClass: "p1"
  }, [_c('span', [_vm._v("累计获得红包")]), _c('span', [_vm._v(_vm._s(_vm.myAnswerAmount.scoreAmount || 0) + "元")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', [_vm._v("可提现金额")]), _c('span', [_vm._v(_vm._s(_vm.canAmount || 0) + "元")])]), _vm._v(" "), (_vm.wxUserInfo.userDataStatus < 2) ? _c('p', {
    staticClass: "p3"
  }, [_c('span', [_vm._v("仅限医生提现，快去")]), _c('span', {
    on: {
      "click": _vm.toWs
    }
  }, [_vm._v("完善信息")])]) : _vm._e()]), _vm._v(" "), _c('x-button', {
    staticClass: "send_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.ATM.apply(null, arguments)
      }
    }
  }, [_vm._v("立即提现")])], 1), _vm._v(" "), _c('img', {
    staticClass: "img1",
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E6%88%91%E7%9A%84%E7%BA%A2%E5%8C%85%E9%A1%B5-%E8%A3%85%E9%A5%B0%E5%85%83%E7%B4%A0@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bt_box"
  }, _vm._l((_vm.btList), function(item, index) {
    return _c('div', {
      class: ['tab_bt', _vm.btIndex == index ? 'active_bt' : 'not_bt'],
      on: {
        "click": function($event) {
          return _vm.tabClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "getHbs",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.recordList.length) ? _c('ul', {
    ref: "box",
    staticClass: "ul_box",
    style: ({
      transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"),
      transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms")
    })
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('li', {
      staticClass: "lis"
    }, [_c('span', {
      staticClass: "h_s1"
    }, [_vm._v(_vm._s(_vm._f("mmdd")(item.createTime)))]), _vm._v(" "), (_vm.btIndex == 0 && item.redPack) ? _c('span', {
      staticClass: "h_s2"
    }, [_vm._v(_vm._s(item.courceType == 1 ? '拼图得红包' : '好友分享'))]) : (_vm.btIndex == 0 && item.integral) ? _c('span', {
      staticClass: "h_s2"
    }, [_vm._v("鼓励奖")]) : _c('span', {
      staticClass: "h_s2",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("提现")]), _vm._v(" "), (_vm.btIndex == 0 && item.redPack) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")]) : (_vm.btIndex == 0 && item.integral) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v(_vm._s(item.integral) + "积分")]) : (_vm.btIndex == 1) ? _c('span', {
      staticClass: "h_s3"
    }, [_vm._v("￥" + _vm._s(item.cashAmount) + "元")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.recordList.length) ? _c('div', {
    staticClass: "no_more"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E6%88%91%E7%9A%84%E7%BA%A2%E5%8C%85%E9%A1%B5-%E7%BC%BA%E7%9C%81@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("什么都没有")])]) : _vm._e()]), _vm._v(" "), _c('guide-cover')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-baa893a4"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/MyRedPacket/index.vue
// module id = 244
// module chunks = 1